<template>
  <div>
    <NuxtLoadingIndicator color="#000" />
    <NuxtLayout>
      <div class="sm:mt-16">
        <NuxtPage />
      </div>
    </NuxtLayout>

    <BaseAppToast />
    <NewArtwork />
    <MobileDrawer />
  </div>
</template>

<script setup lang="ts">
const collect = useCollectStore();

onMounted(async () => {
  if (import.meta.client) {
    await collect.trackVisitor();
  }
});
</script>
